import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getToken, storeToken, removeToken } from './LocalStorageService'

const rawBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000/',
  prepareHeaders: (headers) => {
    const { access_token } = getToken()
    if (access_token) {
      headers.set('authorization', `Bearer ${access_token}`)
    }
    return headers
  },
})

// Access tokens are short-lived (15 min). Rather than forcing a fresh login
// every 15 minutes, transparently use the refresh token to get a new access
// token on a 401 and retry the original request once before giving up.
export const authenticatedBaseQuery = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions)

  if (result.error && result.error.status === 401) {
    const { refresh_token } = getToken()
    if (refresh_token) {
      const refreshResult = await rawBaseQuery(
        { url: 'user/refresh/', method: 'POST', body: { refresh: refresh_token } },
        api, extraOptions,
      )
      if (refreshResult.data) {
        storeToken({ access: refreshResult.data.access, refresh: refreshResult.data.refresh || refresh_token })
        result = await rawBaseQuery(args, api, extraOptions)
      } else {
        removeToken()
        window.location.href = '/login'
      }
    } else {
      removeToken()
      window.location.href = '/login'
    }
  }

  return result
}
